module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"<%= (model.additionalClasses || []).join(' '); %>\">\n<%\nvar title = model.title;\nvar text = model.text;\nif(environment.style == 'mobile') {\ntitle = (model.titleMobile != \"\" ? model.titleMobile : title);\ntext = (model.textMobile != \"\" ? model.textMobile : text);\n}\n%>\n<div class=\"title trigger\">\n<h3><%- title %></h3>\n<%\nif(config.collapsable){\n%>\n<div class=\"toggle\">\n<div class=\"minus visibleWhenOpened\"></div>\n<div class=\"plus visibleWhenClosed\"></div>\n</div>\n<%\n}\n%>\n</div>\n<div class=\"content\">\n<div class=\"map\">\n<iframe src=\"<%= model.mapURL %>\" allowfullscreen></iframe>\n</div>\n<div class=\"texts\">\n<%- text %>\n<%#- include('../../button/button', { model: model }); %>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/project/map/map.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"")
    ; __append(escapeFn( (model.additionalClasses || []).join(' ') ))
    ; __append("\">\n")
    ; __line = 2
    ; 
var title = model.title;
var text = model.text;
if(environment.style == 'mobile') {
title = (model.titleMobile != "" ? model.titleMobile : title);
text = (model.textMobile != "" ? model.textMobile : text);
}

    ; __line = 9
    ; __append("\n<div class=\"title trigger\">\n<h3>")
    ; __line = 11
    ; __append( title )
    ; __append("</h3>\n")
    ; __line = 12
    ; 
if(config.collapsable){

    ; __line = 14
    ; __append("\n<div class=\"toggle\">\n<div class=\"minus visibleWhenOpened\"></div>\n<div class=\"plus visibleWhenClosed\"></div>\n</div>\n")
    ; __line = 19
    ; 
}

    ; __line = 21
    ; __append("\n</div>\n<div class=\"content\">\n<div class=\"map\">\n<iframe src=\"")
    ; __line = 25
    ; __append(escapeFn( model.mapURL ))
    ; __append("\" allowfullscreen></iframe>\n</div>\n<div class=\"texts\">\n")
    ; __line = 28
    ; __append( text )
    ; __append("\n")
    ; __line = 29
    ; __append("\n</div>\n</div>\n</div>")
    ; __line = 32
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/map/map.ejs

}